import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { MarkersInfoColors } from "../WinLineInfoMarkers";
export class FairyMagicForestClassic_2Screen extends SlotGameType1_2Screen {
    protected override helpFactory: IHelpFactory = new FairyMagicForestClassicHelpFactory();
    protected override panelColor: ButtonColors = {
        backgroundButtonColor: "linear-gradient(rgb(1, 38, 3),rgb(2, 89, 15), rgb(2, 115, 10),rgb(2, 89, 15),rgb(1, 38, 3)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        linearColor: "linear-gradient(to left , transparent, LightPink,transparent ) 0 10 100%",
    }

    //LED COLOR
    protected override ColorLed: string = "173,83,255\n";
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "FairyMagicForestClassic");
        this.spinnableReelsParams.topBorderWidth = 0;
        this.spinnableReelsParams.bottomBorderWidth = 0;
    }

    //SEND COLOR FOR RSA 
    protected override color: RewardColor =
        {
            color: "#F1F0C9",
            coloroutherStroke: "black",
            colorinnerStroke: "#9F8DF4",
        }

    protected override colorLineMarkers: MarkersInfoColors =
        {
            MarkerbackgroundColor: "linear-gradient(90deg, rgb(1, 38, 3),rgb(2, 89, 15), rgb(2, 115, 10),rgb(2, 89, 15),rgb(1, 38, 3)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };
}

//Panel Colorized
class FairyMagicForestClassicPanelFactory implements IPanelFactory {
    public CreateNewPanel(params: PanelParams): Panel {
        return new FairyMagicForestClassicPanel(params);
    }
}

class FairyMagicForestClassicPanel extends Panel {
    // protected override ButtonBackground(): ButtonColors {
    //     let color: ButtonColors = {
    //         backgroundButtonColor: "linear-gradient(rgb(28, 3, 38),rgb(115, 6, 77), rgb(217, 108, 159),rgb(115, 6, 77),rgb(28, 3, 38)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
    //         linearColor: "linear-gradient(to left , transparent, LightPink,transparent ) 0 10 100%",
    //     };

    //     return color;
    // }

}
class FairyMagicForestClassicHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new FairyMagicForestClassicHelp(params);
    }
}

class FairyMagicForestClassicHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(1, 38, 3),rgb(1, 64, 5), rgb(3, 166, 44),rgb(1, 64, 5),rgb(1, 38, 3)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };
        return color;
    }
}


// }